<ng-template #loaderBlock>
  <app-loader></app-loader>
</ng-template>
<div class="revenue-wrapper">
  <div class="header">
    <h4>EY Revenue Potential by SSL</h4>
    <span>Click to view <a target="_blank" href="https://app.powerbi.com/groups/me/apps/57047177-0dd3-4ced-b6d7-19e86d2de1ab/reports/7cd83ece-193e-4cbc-a53f-4a5ce3b91f77/ReportSection780c34c89e11a6aa7b3b?ctid=5b973f99-77df-4beb-b27d-aa0c70b8482c&experience=power-bi">Walletscan</a></span>
  </div>

  <div [id]="name" class="revenue_potential"></div>
  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
